module.exports = __webpack_public_path__ + "img/ai-2.78309a7a.jpg";